"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RESIDENT_MAPPING = {
    prefix: 'residents',
    list: {
        path: '/list'
    },
    getResident: {
        path: '/getResident',
        parameter: '/:id'
    },
    fetchFacilityResidents: {
        path: '/fetchFacilityResidents',
        parameter: '/:facilityId'
    },
    importResidents: {
        path: '/importResidents',
        parameter: '/:chainId'
    },
    updateResident: {
        path: '/updateResident',
        parameter: '/:id'
    },
    typeOfContactList: {
        path: '/typeOfContactList'
    },
    chainTypeOfContactListMap: {
        path: '/chainTypeOfContactListMap'
    },
    getResidentContactsFromDate: {
        path: '/getResidentContactsFromDate'
    },
    getResidentContacts: {
        path: '/residentContacts',
        parameter: '/:id'
    },
    makeResidentContactPrimary: {
        path: '/makeResidentContactPrimary',
        parameter: '/:residentId/:contactId'
    },
    makeResidentContactForMailing: {
        path: '/makeResidentContactForMailing',
        parameter: '/:residentId/:contactId'
    },
    updateSettings: {
        path: '/updateSettings',
        parameter: '/:residentId'
    },
    getOpenBalance: {
        path: '/getOpenBalance',
        parameter: '/:residentId'
    },
    getSettings: {
        path: '/getSettings',
        parameter: '/:residentId'
    },
    getResidentsStatistics: {
        path: '/getResidentsStatistics'
    },
    initResidentContactsUsedForMailing: {
        path: '/initResidentContactsUsedForMailing',
        parameter: '/:facilityId'
    },
    getResidentsInCollection: {
        path: '/getResidentsInCollection'
    },
    getResidentEventHistory: {
        path: '/getResidentEventHistory',
        parameter: '/:residentId'
    },
    getResidentPaymentMethods: {
        path: '/getResidentPaymentMethods',
        parameter: '/:residentId'
    },
    getResidentCollectionTask: {
        path: '/getResidentCollectionTask',
        parameter: '/:residentId'
    },
    deletePaymentMethod: {
        path: '/deletePaymentMethod',
        parameter: '/:paymentMethodId'
    },
    makeResidentPaymentMethodPrimary: {
        path: '/makeResidentPaymentMethodPrimary',
        parameter: '/:residentId/:paymentMethodId'
    },
    addPaymentMethod: {
        path: '/addPaymentMethod',
        parameter: '/:residentId'
    },
    setupFacilityResidentContactSettings: {
        path: '/setupFacilityResidentContactSettings'
    }
};
